import "amazon-connect-streams";

export default function hasCustomerLeft(contact: connect.Contact): boolean {
    return contact.getActiveInitialConnection() === null;
}
